<template>
  <div class="upload-file-main">
    <div v-if="auth" class="upload-btn-box">
      <el-button type="primary" @click="showUploadBox">上传附件</el-button>
    </div>
    <div class="upload-table-box" :class="auth ? '' : 'full'">
      <el-table
        ref="table"
        size="mini"
        style="width: 100%"
        height="100%"
        :data="tableData"
        border
        stripe
      >
        <el-table-column label="附件名称" prop="fileName"></el-table-column>
        <el-table-column label="上传人" prop="createUserName" width="200"></el-table-column>
        <el-table-column label="上传时间" width="200">
          <template #default="{ row }">
            {{ dateFormat(row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="113px" align="center">
          <template #default="{ row }">
            <el-button type="text" class="text-xs" @click="downloadFile(row)">下载</el-button>
            <el-button type="text" v-if="auth && row.createUserId === userId" class="text-xs delete" @click="deleteFile(row)">删除</el-button>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <!--多文件附件上传input-->
    <input id="fileUploadFile" class="upload-file-box" type="file" multiple @change="multiUpload" />
  </div>
</template>

<script>
import { dateFormat } from "../../../mobile/util";
import { Loading } from "element-ui";
import request from "../../api/request";
import { getCookie, getStorage } from "@szgc/plt-core-v2";

export default {
  props: {
    config: {
      type: Object,
      default() {
        return null;
      }
    },
    auth: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      prefix: "",
      userId: "",
      tableData: [],
      fileUpdLoading: null,
      token: getCookie("SZGC-SHIRO-TOKEN") || getStorage("SZGC-SHIRO-TOKEN") || ""
    };
  },
  watch: {
    config: {
      handler(val) {
        if (val && val.businessId) {
          this.prefix = getCookie("plt-api-route") || getStorage("plt-api-route") || "";
          this.getCurrent();
          this.getTable();
        }
      },
      immediate: true,
      deep: true
    }
  },
  methods: {
    /*时间转换*/
    dateFormat(date) {
      return date ? dateFormat(date) : "--";
    },
    /*获取当前登录人信息*/
    async getCurrent() {
      request({
        url: this.prefix + `/secure/current?SZGC-SHIRO-TOKEN=${this.token}`,
        method: "get"
      })
        .then((res) => {
          if (res.success) {
            this.userId = res.data.userId;
          } else {
            this.$message.error("获取当前登录用户失败");
          }
        })
        .catch((error) => {
          this.$message.error("获取当前登录用户失败: " + error);
        });
    },
    /*获取附件列表*/
    async getTable() {
      try {
        const { success, message, data } = await request({
          url:
            this.prefix +
            `/api/appproc/read/${this.config.businessId}/matter-attchment-list?SZGC-SHIRO-TOKEN=` +
            this.token,
          method: "get"
        });
        if (!success) {
          return this.$message.error("获取附件列表失败:" + message);
        }
        this.tableData = data;
      } catch (error) {
        this.$message.error("获取附件列表失败");
      }
    },
    /*附件box点击*/
    showUploadBox() {
      document.getElementById("fileUploadFile").value = "";
      document.getElementById("fileUploadFile").click();
    },
    /*多文件上传*/
    multiUpload(event) {
      let files = event.target.files;
      let formData = new FormData();
      if (files.length === 0) {
        return false;
      }
      for (let i = 0; i < files.length; i++) {
        formData.append("files", files[i]);
      }
      formData.append("reqToken", this.config.reqToken);
      this.fileUpdLoading = Loading.service({
        lock: true,
        fullscreen: true,
        text: "附件上传中..."
      });
      request({
        url:
          this.prefix +
          `/api/appproc/packages/${this.config.pacId}/matters/${this.config.businessId}/attachments-list/multi-upload?SZGC-SHIRO-TOKEN=${this.token}`,
        method: "post",
        data: formData
      })
        .then((res) => {
          if (res.success) {
            this.getTable();
          } else {
            this.$message.error("附件上传失败");
          }
          this.fileUpdLoading.close();
        })
        .catch((error) => {
          this.fileUpdLoading.close();
          this.$message.error("附件上传失败: " + error);
        });
    },
    downLoadFile(attDownloadUrlField, fileName) {
      const a = document.createElement("a");
      a.style = "display: none"; // 创建一个隐藏的a标签
      a.download = fileName;
      a.href = attDownloadUrlField;
      document.body.appendChild(a);
      a.click(); // 触发a标签的click事件
      document.body.removeChild(a);
    },
    /*下载附件*/
    downloadFile(row) {
      let url = "";
      if (this.prefix) {
        url = `${this.prefix}/${row.requestRelativeUri}?SZGC-SHIRO-TOKEN=${this.token}`;
      } else {
        url = `${window.location.origin}/${row.requestRelativeUri}?SZGC-SHIRO-TOKEN=${this.token}`;
      }
      this.downLoadFile(url, row.fileName);
    },
    /*删除附件*/
    async deleteFile(row) {
      let confirm;
      try {
        confirm = await this.$confirm(`确认删除该附件?`, "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          closeOnClickModal: false,
          type: "warning"
        });
      } catch (e) {
        confirm = null;
      }
      if (!confirm) {
        return false;
      }
      try {
        const { success, message } = await request({
          url:
            this.prefix +
            `/api/appproc/packages/${this.config.pacId}/matters/${this.config.businessId}/attachments-list?SZGC-SHIRO-TOKEN=${this.token}`,
          method: "delete",
          data: {
            attachIds: [row.attId]
          }
        });
        if (!success) {
          return this.$message.error("删除附件失败:" + message);
        }
        await this.getTable();
      } catch (error) {
        this.$message.error("删除附件失败");
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.upload-file-main {
  width: 100%;
  height: 100%;

  .upload-btn-box {
    padding: 20px;
  }

  .upload-table-box {
    width: 100%;
    height: calc(100% - 68px);

    &.full {
      position: relative;
      top: -1px;
      height: 100%;
    }

    // .download {
    //   color: var(--szgc-element-primary);
    //   cursor: pointer;
    //   margin: 0 5px;
    // }

    .delete {
      color: var(--szgc-element-danger-color);
      &:hover {
        color: var(--szgc-element-danger-color-light);
      }
    }
  }
}
</style>

